<template>
  <el-dialog
    :visible.sync="visible"
    append-to-body
    :show-close="true"
    :center="true"
    :before-close="handleClose"
    title="添加地址"
    width="800px"
    class="center-dialog"
    top="0vh"
  >
    <div>
      <el-form ref="form" :model="formData"  :rules="rules" label-width="120px">
        <div  v-for="(item, index) in formData.addressList" :key="index" 
        style="border-bottom:1px solid #c1c1c1;padding:10px;margin-top:30px;position: relative;">
          <span class="del" @click="del(index)">删除</span>
            <el-row >
                <el-form-item label="店铺名称"   :prop="'addressList.' + index + '.shop_name'" :rules="rules.shop_name">  
                  <el-input  type="text"  v-model="formData.addressList[index].shop_name" ></el-input> 
                 
                </el-form-item>

      
                <el-form-item label="项目" :prop="'addressList.' + index + '.project_id'" :rules="rules.project_id">
                  <el-select
                     v-model="formData.addressList[index].project_id" 
                          clearable
                          filterable
                          placeholder="请选择项目"
                          style="width:100%"
                        >
                        <el-option
                          v-for="item in projectList"
                          :key="item.project_id"
                          :label="item.name"
                          :value="item.project_id"
                        />
                  </el-select>
                </el-form-item>


                

                <el-form-item label="地址	"  :prop="'addressList.' + index + '.adname'" :rules="rules.adname" >  
                  <el-input  type="text" v-model="item.adname" @focus="selectPoint(index)" ></el-input> 
                </el-form-item>

                <el-form-item label="详细地址"  :prop="'addressList.' + index + '.address'" :rules="rules.address" >
                  <el-input v-model="item.address" ></el-input>
                </el-form-item>
            </el-row> 
           
        </div>

        <div style="text-align:center;margin-top: 20px;">
          <el-button @click="addComponents">+添加</el-button>
        </div>

      </el-form>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </span>

    <select-point-dialog ref="mapDialog"  @setAddress="setAddress"></select-point-dialog>

  </el-dialog>
</template>

<script>
import { addressList,addAddress,delAddress,batchAddAddress } from "@/api/director/address/index";
import { projectList} from "@/api/director/project/index";

import selectPointDialog from "@/components/map/select-point-dialog.vue";

export default {
  components: { selectPointDialog},

  data() {
    return {
      visible: false,
      index:null,
      projectList:[],

      formData: {
        addressList:[
            {
            project_id:"",
            shop_name:"",
            adname:"",
            address: "",
            remark: "",
            lat:"",
            lng:""
          }
        ]
      },
       rules: {
        project_id: [
              {required: true, message: '请选择项目', trigger: 'blur'}
          ],
          shop_name: [
                {required: true, message: '请输入店铺名称', trigger: 'blur'}
            ],
          adname: [
                {required: true, message: '请输入地址', trigger: 'change'}
            ],
          address: [
              {required: true, message: '请输入详细地址', trigger: 'blur'}
          ],

          

       }
    };
  },
 
  mounted() {

},
  
  methods: {
    handleClose() {
      this.$refs["form"].resetFields();
      this.visible = false;

    },


    init() {
      this.visible = true;
      this.initProjectList();
    },

    selectPoint(index){
      this.index=index;
      this.$refs.mapDialog.init();
    },


    setAddress(data){
      console.log(data)
      this.formData.addressList[this.index].lat=data.lat;
      this.formData.addressList[this.index].lng=data.lng;
      this.formData.addressList[this.index].adname=data.address;
      
    },

    initProjectList(){
      var that = this;
      projectList({}).then((response) => {
        console.log('projectList',response);
        that.projectList = response.data;
      });
    },
    
    del(index){
      this.formData.addressList.splice(index,1)
    },

    addComponents(){
        this.formData.addressList.push( 
          {
            project_id:'',
            shop_name:"",
            adname:"",
            address: "",
            lat:"",
            lng:""
          });
      },
    
    submit(){
      var that=this;
    

      this.$refs["form"].validate((valid) => {
          if (valid) {
            var params={
              addressList:this.formData.addressList
            }
            batchAddAddress(params).then((response) => {
              console.log(response);
              if(response.code==200){
                this.$message({
                   message: "提交成功",
                   type: 'success'

                });
                /*
                var addressList=[];
                for (let item of response.data) {
                    addressList.push(
                      item
                    );
                }*/
                that.$emit('addAndSetAddress');
                that.visible = false;
              
              }else{
                this.$message({
                  message: response.msg?response.msg:"提交失败",
                });
              }
            });
          } 
        });

    },

    
  },

 
};
</script>

<style lang="scss" scoped>


  .del{
    position: absolute;
    right: -10px;
    top: -20px;
    z-index: 10;
    border: 1px solid #4c71db;
    color: #4c71db;
    padding: 2px 10px;
    border-radius: 2px;
    cursor: pointer;
  }
</style>
